<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="square">
        <path d="M10.984 11.967c0-.737 1.229-2.212 1.229-2.212s1.229 1.505 1.229 2.212c0 .707-.615 1.167-1.23 1.167-.614 0-1.228-.43-1.228-1.167zM7.912 1.154H2.997c-1.014 0-1.843.829-1.843 1.843v.614M1.154 3.611h11.673c1.014 0 1.843.83 1.843 1.843 0 1.014-.829 1.844-1.843 1.844H4.84v7.372H1.154V3.611z"/>
    </g>
</svg>
